import { EnvironmentType } from 'constants/environment';

import { getEnvironment } from './feature-toggle';

// These integrations must not enter the legacy chat-channel capability map.
const clientIdsPerEnvironment: Record<EnvironmentType, readonly string[]> = {
  [EnvironmentType.Labs]: [
    'e0958356c33d0356061eccb77e06b9fb', // WhatsApp
    'cc67d9a8de61331cb1ca588fe25dca99', // Telegram
    '8bb2decce80d4ce483699a5033eab1b5', // Instagram
    '3e9f873b9e1a17c7d9823cbd2dd34266', // InfobipSMS
  ],
  [EnvironmentType.Staging]: [
    '2926ef6628436159cd1accd79f47fdc2', // WhatsApp
    '09b067a3a0191e00900ad9a0a9570c46', // Telegram
    '8eb4f4af5b0575e55a45cfe6b7eeedaf', // Instagram
    '1413356f60b0c8e89170dc9bf89256e6', // InfobipSMS
  ],
  [EnvironmentType.Production]: [
    'c437be81fadb844ef85c06305ce026a2', // WhatsApp
    'dc3cb1853ac875d69215c6fbdb261b3f', // Telegram
    '84cee40ac9b731a877c964bc3ee0ca17', // Instagram
    '307da84d21c44141342b4b4b2cd2bd96', // InfobipSMS
  ],
};

export function isTextNativeChannelClientId(clientId: string | undefined): boolean {
  return !!clientId && clientIdsPerEnvironment[getEnvironment(true)].includes(clientId);
}
